import React from 'react';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function Financing() {
  const steps = [{
    number: '1',
    title: 'Apply in 2 Minutes',
    desc: 'Quick digital application'
  }, {
    number: '2',
    title: 'Instant On-Site Approval',
    desc: 'No long waiting periods'
  }, {
    number: '3',
    title: '$0 Down Payment Options',
    desc: 'Start treatment today'
  }];
  return <section className="py-20 bg-white border-y border-slate-100" data-id="element-117">
      <div className="max-w-7xl mx-auto px-4" data-id="element-118">
        <div className="text-center mb-16" data-id="element-119">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-3xl md:text-4xl font-bold text-[#225274] mb-4" data-id="element-120">
            AFFORDABLE FLEXIBLE FINANCING
          </motion.h2>
          <p className="text-xl text-[#4F709C]" data-id="element-121">
            Get your dream smile today with one of the best financing options
            around—Up to 3 Years (36 Months) Flex-Pay.
          </p>
        </div>

        <div className="relative" data-id="element-122">
          {/* Timeline Line */}
          <div className="hidden md:block absolute top-10 left-0 right-0 h-0.5 bg-slate-100 z-0" data-id="element-123" />

          <div className="grid md:grid-cols-3 gap-12 relative z-10" data-id="element-124">
            {steps.map((step, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: idx * 0.15
          }} className="flex flex-col items-center text-center" data-id="element-125">
                <div className="w-20 h-20 bg-white border-4 border-[#54c595] rounded-full flex items-center justify-center mb-6 shadow-lg" data-id="element-126">
                  <span className="text-2xl font-bold text-[#225274]" data-id="element-127">
                    {step.number}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-[#225274] mb-2" data-id="element-128">
                  {step.title}
                </h3>
                <p className="text-slate-500" data-id="element-129">{step.desc}</p>
              </motion.div>)}
          </div>
        </div>

        <div className="mt-16 text-center" data-id="element-130">
          <a href="/financing" className="inline-flex bg-gradient-to-r from-[#225274] via-[#4bafbc] to-[#54c595] hover:brightness-110 text-white px-10 py-4 rounded-full font-bold text-lg items-center gap-2 mx-auto transition-all uppercase tracking-widest" data-id="element-131">
            APPLY FOR FINANCING NOW
            <ArrowRight size={20} data-id="element-132" />
          </a>
        </div>
      </div>
    </section>;
}